// Note: GSAP and ScrollTrigger are now imported via the utility.
// We only need to import and call our new function.
import { initializePageAnimations } from './utils/animationUtils.js';

// Import Sortable.js and expose globally for CSR components
import Sortable from 'sortablejs';
window.Sortable = Sortable;

// Initialize GSAP animations
document.addEventListener('DOMContentLoaded', () => {
    // --- REFACTORED: Centralized animation initialization ---
    // This single function now handles all on-load and on-scroll animations
    // based on data attributes in the HTML.
    initializePageAnimations();


    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            if (targetId === '#') return;
            
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    });
    
   // --- New code to handle session expiration ---
   const urlParams = new URLSearchParams(window.location.search);
   if (urlParams.get('session') === 'expired') {
       console.log('Session expired, opening login modal.');
       
       // Check if the auth modal service is available before calling it
       if (window.authModalService) {
           window.authModalService.openLoginModal();
       }

       // Clean the URL so the modal doesn't re-open on refresh
       // This replaces the current history entry, so the back button still works correctly
       const newUrl = window.location.pathname; // Get the path without query params
       history.replaceState(null, '', newUrl);
   }

    // --- Component Targeting from URL Hash ---
    const handleHashChange = () => {
        const hash = window.location.hash.substring(1);
        if (!hash) return;

        const targetElement = document.getElementById(hash);
        if (targetElement) {
            // Find the toggle button for the panel
            const toggleButton = targetElement.querySelector('.admin-panel-toggle');
            if (toggleButton) {
                // Check if the panel is already open
                const content = targetElement.querySelector('.hidden');
                if (content) {
                    // The panel is closed, so open it
                    toggleButton.click();
                }
            }

            // Scroll to the element
            setTimeout(() => {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 300); // Delay to allow for panel expansion animation
        }
    };

    // Handle on initial load
    handleHashChange();

    // Handle on hash change
    window.addEventListener('hashchange', handleHashChange, false);
});

// Note: Socket.IO connections are handled by individual components
// (heroSectionClient.js, sectionClient.js, etc.) with websocket-only transport.
// Do NOT add a generic io() connection here - it causes unnecessary polling.
